export default "__VITE_ASSET__32ac43a1__"